<template>
    <div class="form-field form-field--checkbox">
          <div class="label">
              {{ title }}
              <span>{{ subtitle }}</span>
          </div>
  
          <div class="image-checkbox" >      
              <label v-for="choice in choices">
  
                  <input
                    type="checkbox"
                    v-model="state[choice.label]"
                    :disabled="value.length >= max && value.indexOf(choice.label) == -1"
                  />
                  <span class="image-checkbox__text">
                      {{ choice.label }} <span class="image-checkbox__number" v-if="choice.description">{{ choice.description }}</span>
                  </span>
              </label>
          </div>

          <input-text v-model="customValue" v-if="hasCustom" :label="otherLabel" name="other" />
      </div>
  </template>
  
  <script>
  import InputText from './InputText.vue';
  export default {
      name: "MultipleChoice",
      components: {InputText},
      props: {
          title: '',
          subtitle: '',
          name: {},
          otherLabel: {
            type: String, 
          },
          otherValue: {
            type: String, 
          },
          modelValue: {
            type: Array,
            default: [],
          },
          img: {},
          max: {
            type: Number,
            default: -1,
          },
          choices: {
            type: Array,
            default: [],
          },
      },
    data(){
        const state = {};
        this.choices.forEach((choice) => {
            state[choice.label] = this.modelValue.indexOf(choice.label) != -1;
        });

        let customValue = '';
        const labels = this.choices.map((choice) => choice.label);
        const customValues = this.modelValue.filter((value) => {
            return labels.indexOf(value) == -1
        })
        if (customValues.length >= 1) {
            state[this.otherValue] = true;
            customValue = customValues[0];
        }
        return {
            state,
            customValue,
        };
    },
    computed: {
        hasCustom() {   
            const labels = this.choices.map((choice) => choice.label);
            return this.value.filter((value) => {
                return labels.indexOf(value) == -1
            }).length > 0;
        },
        value() {
            return this.choices.filter((choice) => this.state[choice.label]).map((choice) => { 
                if (choice.label == this.otherValue) {
                    return this.customValue;
                }
                return choice.label;
            });
        }
    },
    watch: {
      value(){
        this.$emit('update:modelValue', this.value);
      },
    }
  }
  </script>
  
  <style scoped>
      .image-checkbox {
          border-radius: 7px;
          overflow: hidden;
          border: solid 1px #dadde2;
          display: flex;
          flex-direction: column;
      }

      .image-checkbox label:first-child {
        border-top: 0;
      }
  
      .image-checkbox__number {
          display: inline-block;
          margin-left: 12px;
          opacity: 0.5;
          font-size: 1.4rem;
          line-height: 1.43;
      }
  
      label {
          display: flex;
          align-items: center;
          position: relative;
          padding: 18px;
          border-top: 1px solid #dadde2;
          font-size: 1.6rem;
          line-height: 1.25;
          font-weight: normal;
          margin: 0;
      }
  
      input {
          position: absolute;
          right: 18px;
          top: 50%;
          transform: translateY(-50%);
          border: solid 1px #dadde2;
          width: 24px;
          height: 24px;
          border-radius: 5px;
          -webkit-appearance: none;
          appearance: none;
          background-color: white;
          margin: 0;
      }
  
      input:before {
          content: '';
          position: absolute;
          width: 10px;
          height: 9px;
          display: block;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          opacity: 0;
          background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMiAxMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMSA2IDQgNCA2LTkiIHN0cm9rZT0iI0ZBRjhGNCIgc3Ryb2tlLXdpZHRoPSIxLjQiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+");
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center center;
      }
  
      input:checked {
          border-color: #da503b;
          background: #da503b;
      }
  
      input:checked:before {
          opacity: 1;
      }
  </style>
  